import { ProductsInsurancePlan } from '@src/data/types/ProductsWorksheetSchema'
import { CreditApplication, Merchant } from '../../../../data/types'
import { IFinanceBaseWorksheet } from '../../../../data/types/IFinanceBaseWorksheetSchema'
import { MerchantPaymentPlan } from '../../../../data/types/MerchantPaymentPlan'
import BorrowersSection from './BorrowerSection'
import FinancingSection from './FinancingSection'
import FundingSection from './FundingSection'
import SectionContainer from './SectionContainer'

interface Props {
  worksheet: IFinanceBaseWorksheet
  creditApplication: CreditApplication
  paymentMerchantsByIds?: Record<string, Merchant> | null
  totalObligation: number
  merchantPaymentPlan: MerchantPaymentPlan | null
  productsPlans: ProductsInsurancePlan[]
  showTransactionSection?: boolean
  showFundingSection?: boolean
}

const TransactionSection = ({
  worksheet,
  creditApplication,
  paymentMerchantsByIds,
  totalObligation,
  merchantPaymentPlan,
  productsPlans,
  showTransactionSection = true,
  showFundingSection = true,
}: Props) => {
  return (
    <SectionContainer showTransactionSection={showTransactionSection}>
      <FinancingSection
        worksheet={worksheet}
        creditApplication={creditApplication}
        totalObligation={totalObligation}
        merchantPaymentPlan={merchantPaymentPlan}
      />
      <BorrowersSection worksheet={worksheet} />
      <FundingSection
        worksheet={worksheet}
        creditApplication={creditApplication}
        paymentMerchantsByIds={paymentMerchantsByIds}
        productsPlans={productsPlans}
        showFundingSection={showFundingSection}
      />
    </SectionContainer>
  )
}

export default TransactionSection